(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-parallax-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('scroll-parallax-hero')) {
    class ScrollParallaxHero extends HTMLElement {
      constructor() {
        super();
        this.panels = [];
        this.titleButtons = [];
        this.discoverLinks = [];
        this.videos = [];
        this.rafId = null;
        this.videoObserver = null;
        this.prefersReducedMotion = false;
        this._onScroll = this._onScroll.bind(this);
      }

      connectedCallback() {
        this.panels = Array.from(this.querySelectorAll('[data-panel-id]'));
        this.titleButtons = Array.from(this.querySelectorAll('[data-panel-target]'));
        this.discoverLinks = Array.from(this.querySelectorAll('[data-discover-for]'));
        this.videos = Array.from(this.querySelectorAll('video[data-autoplay-on-intersect]'));

        const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.prefersReducedMotion = mq.matches;
        mq.addEventListener('change', (e) => { this.prefersReducedMotion = e.matches; });

        this._setupVideoObserver();
        this._setupClicks();

        window.addEventListener('scroll', this._onScroll, { passive: true });
        window.addEventListener('resize', this._onScroll, { passive: true });

        // Initial state
        this._update();
      }

      disconnectedCallback() {
        if (this.videoObserver) this.videoObserver.disconnect();
        window.removeEventListener('scroll', this._onScroll);
        window.removeEventListener('resize', this._onScroll);
        if (this.rafId) cancelAnimationFrame(this.rafId);
      }

      _setupVideoObserver() {
        if (!('IntersectionObserver' in window)) return;
        this.videoObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const video = entry.target;
            const threshold = parseFloat(video.dataset.autoplayOnIntersect) || 0.5;
            if (entry.isIntersecting && entry.intersectionRatio >= threshold) {
              if (this.prefersReducedMotion) return;
              const p = video.play();
              if (p && typeof p.catch === 'function') p.catch(() => { /* autoplay blocked, ignore */ });
            } else {
              video.pause();
            }
          });
        }, { threshold: [0, 0.25, 0.5, 0.75, 1] });

        this.videos.forEach((v) => this.videoObserver.observe(v));
      }

      _setupClicks() {
        this.titleButtons.forEach((btn) => {
          btn.addEventListener('click', (e) => {
            const target = btn.dataset.panelTarget;
            const href = btn.dataset.href;
            const isActive = this.dataset.active === target;

            if (isActive && href) {
              window.location.href = href;
              return;
            }

            const panel = this.querySelector('[data-panel-id="' + target + '"]');
            if (panel) {
              const behavior = this.prefersReducedMotion ? 'auto' : 'smooth';
              panel.scrollIntoView({ behavior: behavior, block: 'start' });
            }
          });
        });
      }

      _onScroll() {
        if (this.rafId) return;
        this.rafId = requestAnimationFrame(() => {
          this._update();
          this.rafId = null;
        });
      }

      _update() {
        if (!this.panels.length) return;
        const viewportCenter = window.innerHeight / 2;
        let closestPanel = null;
        let closestDistance = Infinity;

        for (let i = 0; i < this.panels.length; i++) {
          const rect = this.panels[i].getBoundingClientRect();
          const center = rect.top + rect.height / 2;
          const distance = Math.abs(center - viewportCenter);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestPanel = this.panels[i];
          }
        }

        if (!closestPanel) return;
        const id = closestPanel.dataset.panelId;
        if (this.dataset.active === id) return;

        this.dataset.active = id;

        // Update title buttons
        for (let i = 0; i < this.titleButtons.length; i++) {
          const btn = this.titleButtons[i];
          const match = btn.dataset.panelTarget === id;
          if (match) {
            btn.setAttribute('data-active', '');
            btn.setAttribute('aria-selected', 'true');
          } else {
            btn.removeAttribute('data-active');
            btn.setAttribute('aria-selected', 'false');
          }
        }

        // Update discover links
        for (let i = 0; i < this.discoverLinks.length; i++) {
          const link = this.discoverLinks[i];
          if (link.dataset.discoverFor === id) {
            link.setAttribute('data-active', '');
          } else {
            link.removeAttribute('data-active');
          }
        }
      }
    }

    customElements.define('scroll-parallax-hero', ScrollParallaxHero);
  }

  } catch(e) { console.error(e); }
})();
})();
